import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import './AppPrint.css';
import PrivateRoute from './PrivateRoute';

import IndexListaQrCode from './modules/agenda/IndexListaQrCode';
import NotFound from './NotFound';

export default class extends Component {
  render() {
    return (
      <Switch>
        <PrivateRoute
          roles={[
            'admin',
            'sindico',
            'conselheiro'
          ]} exact path="/print/agenda/qrcode" component={IndexListaQrCode} />
        <Route component={NotFound} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AppPrint.js